/* Armadio di Sofia · galleria della scheda prodotto (mobile) · 3 nov (prima «Storie», 27 oct).
   1) Si scorre col dito o con le frecce grandi ‹ ›, pallini sotto; toccare la foto (o il pulsante
      in alto a destra) la apre intera.
   2) Foto a schermo intero: si apre sulla foto toccata, si scorre tra le foto col dito,
      contatore «2 / 4», doppio tocco per ingrandire (e di nuovo per tornare).
   Per tornare alle «Storie»: annullare il commit del 3 nov (git revert). */
(function () {
  var mql = window.matchMedia('(max-width: 749px)');

  function visibili(list) {
    return Array.prototype.filter.call(list, function (el) {
      return el.offsetParent !== null;
    });
  }

  function vicina(track, items) {
    var max = track.scrollWidth - track.clientWidth;
    if (max > 0 && track.scrollLeft >= max - 2) return items.length - 1;
    var best = 0;
    var dist = Infinity;
    items.forEach(function (el, i) {
      var d = Math.abs(el.offsetLeft - track.scrollLeft);
      if (d < dist) {
        dist = d;
        best = i;
      }
    });
    return best;
  }

  function clamp(n) {
    return Math.min(Math.max(n, 0), 1);
  }

  /* 1) Galleria (3 nov, Javier: «una señora no va a saber el flow de pasar historias»):
        si scorre col dito, frecce grandi ‹ › ai lati, pallini sotto; toccare la foto la apre intera. */
  var ICONA =
    '<svg viewBox="0 0 18 18" aria-hidden="true" focusable="false"><path d="M3 7V3h4M11 3h4v4M15 11v4h-4M7 15H3v-4"/></svg>';
  var SX = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>';
  var DX = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>';

  function setupGalleria(gallery) {
    if (gallery.dataset.clGal) return;
    var viewer = gallery.querySelector('slider-component:not(.thumbnail-slider)');
    var list = viewer && viewer.querySelector('.product__media-list');
    if (!list) return;
    gallery.dataset.clGal = '1';

    function bottone(cls, label, svg) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = cls;
      b.setAttribute('aria-label', label);
      b.innerHTML = svg;
      viewer.appendChild(b);
      return b;
    }
    var prima = bottone('cl-freccia cl-freccia--sx', 'Foto precedente', SX);
    var dopo = bottone('cl-freccia cl-freccia--dx', 'Foto successiva', DX);
    var intera = bottone('cl-gal-full', 'Vedi la foto intera', ICONA);
    var punti = document.createElement('div');
    punti.className = 'cl-punti';
    viewer.appendChild(punti);

    function foto() {
      return visibili(list.querySelectorAll('.product__media-item'));
    }

    function qui() {
      return vicina(list, foto());
    }

    var ticking = false;
    function segna() {
      ticking = false;
      var items = foto();
      if (!items.length) return;
      var i = vicina(list, items);
      Array.prototype.forEach.call(punti.children, function (p, j) {
        p.classList.toggle('is-on', j === i);
      });
      prima.hidden = items.length < 2 || i === 0;
      dopo.hidden = items.length < 2 || i === items.length - 1;
    }

    function disegna() {
      var items = foto();
      punti.hidden = items.length < 2;
      if (punti.children.length !== items.length) {
        punti.innerHTML = items
          .map(function (el, j) {
            return '<button type="button" aria-label="Foto ' + (j + 1) + ' di ' + items.length + '"><i></i></button>';
          })
          .join('');
      }
      segna();
    }

    function vai(i) {
      var items = foto();
      var el = items[Math.min(Math.max(i, 0), items.length - 1)];
      if (el) list.scrollTo({ left: el.offsetLeft, behavior: 'smooth' });
    }

    prima.addEventListener('click', function () {
      vai(qui() - 1);
    });
    dopo.addEventListener('click', function () {
      vai(qui() + 1);
    });
    punti.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (b) vai(Array.prototype.indexOf.call(punti.children, b));
    });

    // Pulsante: apre la foto che si vede a schermo intero
    intera.addEventListener('click', function () {
      var items = foto();
      var item = items[vicina(list, items)];
      var btn = item && item.querySelector('.product__media-toggle');
      var opener = btn && btn.closest('modal-opener');
      var modal = opener && document.querySelector(opener.getAttribute('data-modal'));
      if (modal && modal.show) modal.show(btn);
    });

    list.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(segna);
        }
      },
      { passive: true }
    );
    new MutationObserver(disegna).observe(list, { childList: true });
    window.addEventListener('resize', disegna);
    disegna();
  }

  /* 2) Foto a schermo intero */
  function setupModal(modal) {
    if (modal.dataset.clLb) return;
    var dialog = modal.querySelector('.product-media-modal__dialog');
    var content = modal.querySelector('.product-media-modal__content');
    if (!dialog || !content) return;
    modal.dataset.clLb = '1';

    var info = document.createElement('div');
    info.className = 'cl-lb-info';
    info.setAttribute('aria-hidden', 'true');
    info.innerHTML = '<b></b><span>Tocca due volte per ingrandire</span>';
    dialog.appendChild(info);
    var conta = info.querySelector('b');

    var zoom = document.createElement('div');
    zoom.className = 'cl-zoom';
    zoom.hidden = true;
    dialog.appendChild(zoom);

    function foto() {
      return visibili(content.children);
    }

    function aggiorna() {
      var items = foto();
      conta.hidden = items.length < 2;
      if (items.length) conta.textContent = vicina(content, items) + 1 + ' / ' + items.length;
    }

    var ticking = false;
    content.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            aggiorna();
          });
        }
      },
      { passive: true }
    );

    function chiudiZoom() {
      zoom.hidden = true;
      zoom.innerHTML = '';
      info.hidden = false;
    }

    function apriZoom(img, x, y) {
      var r = img.getBoundingClientRect();
      var nw = img.naturalWidth || 3;
      var nh = img.naturalHeight || 4;
      var s = Math.min(r.width / nw, r.height / nh);
      var dw = nw * s;
      var dh = nh * s;
      var fx = clamp((x - r.left - (r.width - dw) / 2) / dw);
      var fy = clamp((y - r.top - (r.height - dh) / 2) / dh);

      var big = document.createElement('img');
      big.alt = img.alt || '';
      big.setAttribute('width', img.getAttribute('width') || nw);
      big.setAttribute('height', img.getAttribute('height') || nh);
      big.sizes = '220vw';
      if (img.getAttribute('srcset')) big.srcset = img.getAttribute('srcset');
      big.src = img.currentSrc || img.src;

      zoom.innerHTML = '';
      zoom.appendChild(big);
      zoom.hidden = false;
      info.hidden = true;
      window.requestAnimationFrame(function () {
        zoom.scrollLeft = fx * big.offsetWidth - zoom.clientWidth / 2;
        zoom.scrollTop = fy * big.offsetHeight - zoom.clientHeight / 2;
      });
    }

    var ultimo = 0;
    var ux = 0;
    var uy = 0;
    function doppioTocco(e) {
      var now = Date.now();
      var stessoPunto = Math.abs(e.clientX - ux) < 40 && Math.abs(e.clientY - uy) < 40;
      if (now - ultimo < 320 && stessoPunto) {
        ultimo = 0;
        return true;
      }
      ultimo = now;
      ux = e.clientX;
      uy = e.clientY;
      return false;
    }

    content.addEventListener('click', function (e) {
      if (!mql.matches) return;
      var img = e.target.closest('img');
      if (!img || img.parentElement !== content) return;
      if (doppioTocco(e)) apriZoom(img, e.clientX, e.clientY);
    });

    zoom.addEventListener('click', function (e) {
      if (doppioTocco(e)) chiudiZoom();
    });

    // All'apertura: si va alla foto toccata (il tema la manderebbe alla prima)
    new MutationObserver(function () {
      if (!modal.hasAttribute('open')) {
        chiudiZoom();
        return;
      }
      if (!mql.matches) return;
      window.requestAnimationFrame(function () {
        var attiva = content.querySelector(':scope > .active');
        if (attiva && attiva.offsetParent !== null) content.scrollLeft = attiva.offsetLeft;
        aggiorna();
      });
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(setupGalleria);
    document.querySelectorAll('product-modal').forEach(setupModal);
  }

  var timer;
  function later() {
    clearTimeout(timer);
    timer = setTimeout(init, 150);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Se il tema ridisegna la galleria (cambio variante), rimette frecce, pallini e visore
  new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
})();


/* 3) Video nella galleria (27 oct): parte da solo, muto, in loop; se il tema lo mette in pausa e si vede ancora, riparte. */
(function () {
  if (window.clVideoLoop) return;
  window.clVideoLoop = true;
  function avvia(v) {
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function setup() {
    var vids = document.querySelectorAll('.cl-video-loop video');
    if (!('IntersectionObserver' in window)) {
      vids.forEach(avvia);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          en.target._clVis = en.isIntersecting;
          if (en.isIntersecting) avvia(en.target);
          else en.target.pause();
        });
      },
      { threshold: 0.4 }
    );
    vids.forEach(function (v) {
      io.observe(v);
      // Il tema mette in pausa tutti i video quando si cambia foto: se si vede ancora, riparte.
      v.addEventListener('pause', function () {
        setTimeout(function () {
          if (v._clVis && v.paused) avvia(v);
        }, 300);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();


/* 4) Barra del Black Friday fissa sulla foto (3 nov, Javier: «cuando vayas bajando que solo se vea lo de
      black friday y cuando termine la foto ya se puede ir»). Solo mobile e solo nella scheda prodotto.
      La cabecera fa come prima (si nasconde scendendo, torna salendo, sotto la barra). */
(function () {
  var mql = window.matchMedia('(max-width: 749px)');

  function setup() {
    var ann = document.querySelector('.announcement-bar-section');
    var gal = document.querySelector('.product__media-wrapper media-gallery');
    if (!ann || !gal) return;
    var body = document.body;
    var ticking = false;

    function guarda() {
      ticking = false;
      if (!mql.matches) {
        body.classList.remove('cl-bf-fissa', 'cl-bf-via');
        return;
      }
      var h = ann.offsetHeight;
      document.documentElement.style.setProperty('--cl-ann-h', h + 'px');
      var list = gal.querySelector('.product__media-list') || gal;
      body.classList.add('cl-bf-fissa');
      body.classList.toggle('cl-bf-via', list.getBoundingClientRect().bottom <= h);
    }

    function presto() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(guarda);
      }
    }

    window.addEventListener('scroll', presto, { passive: true });
    window.addEventListener('resize', presto);
    guarda();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
